export default function Features() {
  return (
    <section className="py-24 bg-gradient-to-b from-white to-stone-50">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Title Area */}
        <div className="mb-16">
          <h2 className="text-5xl lg:text-6xl font-serif mb-2">選ばれる理由</h2>
          <h3 className="text-4xl lg:text-5xl font-serif italic text-gray-600">プロフェッショナルの証</h3>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {/* Card 1 - Expertise */}
          <div className="bg-gray-900 rounded-3xl p-8 flex flex-col justify-between min-h-[400px]">
            <div>
              <div className="w-16 h-16 bg-gray-700 rounded-full flex items-center justify-center mb-6">
                <span className="text-white text-2xl font-bold">専</span>
              </div>
              <h4 className="text-white text-2xl font-bold mb-4 leading-tight">
                地域密着型の<br />専門知識
              </h4>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              東京23区の不動産市場を熟知した専門スタッフが、最適な物件をご提案いたします。
            </p>
          </div>

          {/* Card 2 - Track Record */}
          <div className="relative rounded-3xl overflow-hidden min-h-[400px]">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20residential%20building%20exterior%20with%20professional%20real%20estate%20photography%2C%20contemporary%20apartment%20complex%20with%20clean%20architecture%20and%20elegant%20design%2C%20high-quality%20property%20showcase%20with%20sophisticated%20lighting%20and%20neutral%20color%20palette%2C%20architectural%20detail%20photography%20with%20refined%20aesthetic%20and%20studio%20quality%20composition&width=600&height=800&seq=feature-track-001&orientation=portrait"
              alt="実績"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-black/20"></div>
            <div className="absolute top-6 left-6">
              <div className="bg-black/50 backdrop-blur-sm rounded-xl px-4 py-2 flex items-center gap-2">
                <i className="ri-trophy-line text-white text-xl"></i>
                <span className="text-white text-sm font-medium">実績</span>
              </div>
            </div>
            <div className="absolute bottom-6 left-6">
              <h4 className="text-white text-3xl font-bold">
                500+件の<br />成約実績
              </h4>
            </div>
          </div>

          {/* Card 3 - Support */}
          <div className="bg-white rounded-3xl p-8 flex flex-col justify-between min-h-[400px] border border-gray-200">
            <div>
              <h4 className="text-gray-900 text-3xl font-serif mb-4 leading-tight">
                24時間対応<br />サポート
              </h4>
              <p className="text-gray-600 text-sm leading-relaxed mb-6">
                お客様のご都合に合わせて、いつでもご相談いただけます。
              </p>
            </div>
            <div className="w-full h-48 rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20real%20estate%20agent%20consultation%20scene%20with%20modern%20office%20interior%2C%20business%20meeting%20atmosphere%20with%20clean%20and%20sophisticated%20setting%2C%20customer%20service%20photography%20with%20warm%20and%20welcoming%20ambiance%2C%20professional%20workplace%20environment%20with%20studio%20lighting%20and%20refined%20aesthetic%20quality&width=600&height=400&seq=feature-support-001&orientation=landscape"
                alt="サポート"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Card 4 - Satisfaction */}
          <div className="bg-gradient-to-br from-rose-100 to-orange-100 rounded-3xl p-8 flex flex-col items-center justify-center min-h-[400px]">
            <div className="text-center">
              <div className="text-8xl font-black text-gray-900 mb-4">98%</div>
              <h4 className="text-gray-900 text-2xl font-bold">お客様満足度</h4>
              <p className="text-gray-700 text-sm mt-4">
                多くのお客様から<br />高い評価をいただいています
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
